import { makeContextModule } from '@cian/react-utils';
import * as React from 'react';

import { useAdfoxParams } from './hooks/useAdfoxParams';

import type { AdfoxContextData } from './types';
import type { PParams } from '../../components/AdfoxBanner/types';

const contextData = makeContextModule<AdfoxContextData>({ contextName: 'AdfoxContextData' });

const {
  Context: { Provider },
} = contextData;

export const { useContext: useAdfoxContext, withContext: withAdfoxContext, Context: AdfoxContext } = contextData;

export type AdfoxContextProviderProps = Omit<AdfoxContextData, 'params'> & {
  children: JSX.Element;
  pParams: PParams;
};

export const AdfoxContextProvider: React.FC<AdfoxContextProviderProps> = props => {
  const { children, pParams, size, postViewAnalyticsData, isSearchResultsOpen, onTemplateClick, onTemplateClose } =
    props;

  const params = useAdfoxParams(pParams);

  const contextValue = React.useMemo<AdfoxContextData>(
    () => ({
      params,
      size,
      postViewAnalyticsData,
      isSearchResultsOpen,
      onTemplateClick,
      onTemplateClose,
    }),
    [params, postViewAnalyticsData, size, isSearchResultsOpen, onTemplateClick, onTemplateClose],
  );

  return <Provider value={contextValue}>{children}</Provider>;
};
